import { render, staticRenderFns } from "./ContentUnitBox.vue?vue&type=template&id=bf9829a8&scoped=true&lang=pug&"
import script from "./ContentUnitBox.vue?vue&type=script&lang=ts&"
export * from "./ContentUnitBox.vue?vue&type=script&lang=ts&"
import style0 from "./ContentUnitBox.vue?vue&type=style&index=0&id=bf9829a8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9829a8",
  null
  
)

export default component.exports